import { useTabs } from '@mews-commander/ui';

export const useLibraryTabs = () =>
    useTabs('/$currentEnterpriseId/Settings/Contracts', ['ExternalTemplates', 'AttachmentLibrary']);
